import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Box,
    Button,
    Checkbox,
    DialogActions,
    DialogContent,
    FormControlLabel, FormGroup,
    InputAdornment,
    TextField
} from '@mui/material';
import { ModalActionProps } from 'models/AutoModals';
import CurrencyFormatField from 'components/common/CurrencyFormatField';
import Currency from 'components/formaters/Currency';
import { InvoiceModel } from 'models/InvoiceModel';
import { removeItemAtIndex } from 'utils/common';


type InvoicePaymentConfirmDialogProps = {
    invoice: InvoiceModel,
    all: InvoiceModel[],
} & ModalActionProps<{ids: number[], amount: number}>

const InvoicePaymentConfirmDialog = ({invoice, all, onFinish}: InvoicePaymentConfirmDialogProps) => {
    const {t} = useTranslation();
    const [amount, setAmount] = useState<number>();
    const [ids, setIds] = useState<number[]>([]);

    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        amount && onFinish({
            ids: [invoice.id, ...ids],
            amount,
        });
    };

    const check = (isChecked: boolean, id: number) => {
        if (isChecked)
            setIds(old => [...old, id]);
        else
            setIds(old => removeItemAtIndex(old, old.findIndex(item => item === id)));
    };

    const filtered = all.filter(i => i.payer.id === invoice.payer.id
        && ((i.type === 'simple' && invoice.type === 'simple') || (i.type !== 'simple' && invoice.type !== 'simple'))
        && i.id !== invoice.id
    );

    return (
        <Box component="form" onSubmit={submit}>
            <DialogContent>
                {t('invoice')} {t('invoice_no_for', {number: invoice.number, payer: invoice.payer.name})} <br/>
                <strong><Currency value={invoice.grandTotal} currency={invoice.currency}/></strong>

                <TextField
                    id="amount"
                    name="amount"
                    label={t('amount_paid')}
                    fullWidth
                    required
                    autoFocus
                    value={amount}
                    onChange={e => setAmount(Number(e.target.value))}
                    InputProps={{
                        inputComponent: CurrencyFormatField as any,
                        startAdornment: <InputAdornment position='start'>¥</InputAdornment>,
                    }}
                />

                {filtered.length > 0 && (
                    <>
                        <Box sx={{mt:3}}>{t('also_confirm_for')}:</Box>
                        <FormGroup>
                            {filtered.map((inv, i) => (
                                <FormControlLabel
                                    key={i}
                                    label={<>{inv.number} (<Currency value={inv.grandTotal} currency={inv.currency}/>)</>}
                                    control={
                                        <Checkbox
                                            checked={ids.includes(inv.id)}
                                            onChange={e => check(e.target.checked, inv.id)}
                                        />
                                    }
                                />
                            ))}
                        </FormGroup>
                    </>
                )}
            </DialogContent>

            <DialogActions>
                <Button type="submit">{t('confirm')}</Button>
            </DialogActions>
        </Box>
    );
};

export default InvoicePaymentConfirmDialog;
